    $( document ).ready(function() {
  $(".upsell-collection-wrapper").owlCarousel({
    slideSpeed: 300,
    paginationSpeed: 400,
    nav: false,
    dots: true,
    loop:true,
    navRewind: true,
    autoplay: false,
    autoplayTimeout: 5000,
    responsive: {
      0: {
        items: 1,
      }
    }
  });
       var indexToRemove = 0;
$(".upsell-collection-wrapper").trigger('remove.owl.carousel', [indexToRemove]).trigger('refresh.owl.carousel');

    //   setTimeout(function() {
    // $(".asc-widget-switch").parent("label").click();
    //  console.log("button clicked")
    // }, 10000);

         $(".grid-product__colors .color-swatch").click(function(){
    // Get the new image URL from data attribute
    var newImage = $(this).data('image');
    // Find the img inside the parent and change the src
        console.log("newImage:" + newImage);
       $(this).parents(".grid-product__content").find('.grid-product__image').attr('src', newImage);
})
       });

$(".upsell-product-single__form").submit(function (e) {
  e.preventDefault();
  let form = $(this);
  let formData = $(this).serialize();
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: formData,
    success: function (data) {
      jQuery.getJSON("/cart.js", function (cart) {});
      // This is event for sidecart
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", {
          detail: {
            product: data, //replace this variable with response
            // addToCartBtn: this.addToCart
          },
        })
      );
    },
    error: function (err) {
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:error", {
          detail: {
            errorMessage: error.description,
          },
        })
      );
    },
  });
});

jQuery(document).on('click', '.product-label-size-trigger', function () {
  $(".product-label-size-trigger").removeClass("active");
  $(this).addClass("active");
  var dataClass = $(this).attr("data-class");
  $(".variant-input-wrap .variant-input label span").addClass("hide");
  $("." + dataClass).removeClass("hide");
})
 // -------------------------countdown timer -------------------------

 const totalTime = 60 * 60 * 1000; // 10 minutes in milliseconds

        function getRemainingTime() {
            const storedEndTime = localStorage.getItem('endTime');

            if (storedEndTime) {
                const endTime = parseInt(storedEndTime, 10);
                const currentTime = new Date().getTime();
                let timeLeft = endTime - currentTime;

                if (timeLeft <= 0) {
                    // Reset timer if time is up
                    timeLeft = totalTime;
                    localStorage.setItem('endTime', currentTime + totalTime);
                }
                return timeLeft;
            } else {
                // Set initial timer
                const newEndTime = new Date().getTime() + totalTime;
                localStorage.setItem('endTime', newEndTime);
                return totalTime;
            }
        }

        function updateTimerDisplay(timeLeft) {
            const hours = Math.floor(timeLeft / (1000 * 60 * 60));
            const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

            document.getElementById('timer').innerHTML =
                `${hours.toString().padStart(2, '0')}:` +
                `${minutes.toString().padStart(2, '0')}:` +
                `${seconds.toString().padStart(2, '0')}`;
        }

        function startCountdown() {
            let timeLeft = getRemainingTime();

            function tick() {
                if (timeLeft <= 0) {
                    // Reset timer when it reaches zero
                    timeLeft = totalTime;
                    localStorage.setItem('endTime', new Date().getTime() + totalTime);
                }

                updateTimerDisplay(timeLeft);
                timeLeft -= 1000;
            }

            tick(); // Call immediately to avoid 1-sec delay
            setInterval(tick, 1000);
        }

        startCountdown();


// ----------------------country codes ------------------------

  // Fetch user's country information using ipinfo.io API
  fetch('https://ipinfo.io/json?token=998d504784a52a') // Replace YOUR_API_TOKEN with your API key
    .then(response => response.json())
    .then(data => {
      const countryCode = data.country; // Country code (e.g., PK)

      // Full list of country codes and country names
      const countryNames = {
        "AF": "Afghanistan",
        "AL": "Albania",
        "DZ": "Algeria",
        "AS": "American Samoa",
        "AD": "Andorra",
        "AO": "Angola",
        "AR": "Argentina",
        "AM": "Armenia",
        "AU": "Australia",
        "AT": "Austria",
        "AZ": "Azerbaijan",
        "BS": "Bahamas",
        "BH": "Bahrain",
        "BD": "Bangladesh",
        "BB": "Barbados",
        "BY": "Belarus",
        "BE": "Belgium",
        "BZ": "Belize",
        "BJ": "Benin",
        "BT": "Bhutan",
        "BO": "Bolivia",
        "BA": "Bosnia and Herzegovina",
        "BW": "Botswana",
        "BR": "Brazil",
        "BN": "Brunei",
        "BG": "Bulgaria",
        "BF": "Burkina Faso",
        "BI": "Burundi",
        "KH": "Cambodia",
        "CM": "Cameroon",
        "CA": "Canada",
        "CV": "Cape Verde",
        "CF": "Central African Republic",
        "TD": "Chad",
        "CL": "Chile",
        "CN": "China",
        "CO": "Colombia",
        "KM": "Comoros",
        "CG": "Congo",
        "CR": "Costa Rica",
        "HR": "Croatia",
        "CU": "Cuba",
        "CY": "Cyprus",
        "CZ": "Czech Republic",
        "DK": "Denmark",
        "DJ": "Djibouti",
        "DM": "Dominica",
        "DO": "Dominican Republic",
        "EC": "Ecuador",
        "EG": "Egypt",
        "SV": "El Salvador",
        "GQ": "Equatorial Guinea",
        "ER": "Eritrea",
        "EE": "Estonia",
        "ET": "Ethiopia",
        "FJ": "Fiji",
        "FI": "Finland",
        "FR": "France",
        "GA": "Gabon",
        "GM": "Gambia",
        "GE": "Georgia",
        "DE": "Germany",
        "GH": "Ghana",
        "GR": "Greece",
        "GD": "Grenada",
        "GU": "Guam",
        "GT": "Guatemala",
        "GN": "Guinea",
        "GY": "Guyana",
        "HT": "Haiti",
        "HN": "Honduras",
        "HU": "Hungary",
        "IS": "Iceland",
        "IN": "India",
        "ID": "Indonesia",
        "IR": "Iran",
        "IQ": "Iraq",
        "IE": "Ireland",
        "IL": "Israel",
        "IT": "Italy",
        "CI": "Ivory Coast",
        "JM": "Jamaica",
        "JP": "Japan",
        "JO": "Jordan",
        "KZ": "Kazakhstan",
        "KE": "Kenya",
        "KI": "Kiribati",
        "KW": "Kuwait",
        "KG": "Kyrgyzstan",
        "LA": "Laos",
        "LV": "Latvia",
        "LB": "Lebanon",
        "LS": "Lesotho",
        "LR": "Liberia",
        "LY": "Libya",
        "LI": "Liechtenstein",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "MG": "Madagascar",
        "MW": "Malawi",
        "MY": "Malaysia",
        "MV": "Maldives",
        "ML": "Mali",
        "MT": "Malta",
        "MH": "Marshall Islands",
        "MR": "Mauritania",
        "MU": "Mauritius",
        "MX": "Mexico",
        "MD": "Moldova",
        "MC": "Monaco",
        "MN": "Mongolia",
        "ME": "Montenegro",
        "MA": "Morocco",
        "MZ": "Mozambique",
        "MM": "Myanmar",
        "NA": "Namibia",
        "NP": "Nepal",
        "NL": "Netherlands",
        "NZ": "New Zealand",
        "NI": "Nicaragua",
        "NE": "Niger",
        "NG": "Nigeria",
        "KP": "North Korea",
        "NO": "Norway",
        "OM": "Oman",
        "PK": "Pakistan",
        "PW": "Palau",
        "PA": "Panama",
        "PG": "Papua New Guinea",
        "PY": "Paraguay",
        "PE": "Peru",
        "PH": "Philippines",
        "PL": "Poland",
        "PT": "Portugal",
        "QA": "Qatar",
        "RO": "Romania",
        "RU": "Russia",
        "RW": "Rwanda",
        "SA": "Saudi Arabia",
        "SN": "Senegal",
        "RS": "Serbia",
        "SG": "Singapore",
        "SK": "Slovakia",
        "SI": "Slovenia",
        "SO": "Somalia",
        "ZA": "South Africa",
        "KR": "South Korea",
        "ES": "Spain",
        "LK": "Sri Lanka",
        "SD": "Sudan",
        "SE": "Sweden",
        "CH": "Switzerland",
        "SY": "Syria",
        "TW": "Taiwan",
        "TJ": "Tajikistan",
        "TZ": "Tanzania",
        "TH": "Thailand",
        "TL": "Timor-Leste",
        "TG": "Togo",
        "TO": "Tonga",
        "TT": "Trinidad and Tobago",
        "TN": "Tunisia",
        "TR": "Turkey",
        "TM": "Turkmenistan",
        "UG": "Uganda",
        "UA": "Ukraine",
        "AE": "United Arab Emirates",
        "GB": "United Kingdom",
        "US": "United States",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VU": "Vanuatu",
        "VE": "Venezuela",
        "VN": "Vietnam",
        "YE": "Yemen",
        "ZM": "Zambia",
        "ZW": "Zimbabwe"
      };

      const countryName = countryNames[countryCode] || countryCode; // Default to code if not found
    //    if (countryCode === "US") {
    //   console.log("Visitor is from the United States");
    // }
      document.getElementById('country-code').innerText = countryCode;
      document.getElementById('country-name').innerText = countryName;
    })
    .catch(error => {
      console.error('GeoIP Error:', error);
      document.getElementById('geo-info').innerText = "Free shipping available!";
    });


// $( document ).ready(function() {
//  setTimeout(function() {
//      $(".sp-text-bottom.sp_powered_by").hide();
//     }, 3000);
// }
// function adjustPricesForUSA() {
// fetch('https://ipapi.co/json/') // You can use any IP geolocation service API
//   .then(response => response.json())
//   .then(data => {
//     if (data.country_name === "United States") {
//        const priceElements = document.querySelectorAll(".codingSharkPrice"); // Adjust selector based on your site's structure

//       priceElements.forEach(priceElement => {
//         // Get the text content of the price element
//         let priceText = priceElement.textContent;

//         // Check if the price contains "AUD" and remove it
//         if (priceText.includes("AUD")) {
//           priceElement.textContent = priceText.replace(" AUD", ""); // Remove " AUD"
//         }
//     })
//       $(".product-label-size-trigger").removeClass("active");
//       $(".product-label-size-trigger-us").addClass("active");
//       $(".variant-input-wrap .variant-input label span").addClass("hide");
//       $(".product-size-us").removeClass("hide");
      
//     }
//     console.log("country_name:" + data.country_name)
//   })
//   .catch(error => {
//     console.error("Error fetching geolocation data:", error);
//   });
// }
// adjustPricesForUSA();